import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const NadPlusPage7: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  const options = ["Yes", "No"];

  useEffect(() => {
    const step6Completed = localStorage.getItem("completed-step-6");
    if(isSermorelinPage){
      if (step6Completed) {
        navigate("/sermorelin/getting-started/step-7", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-6", { replace: true });
      }
    }else{
    if (step6Completed) {
      navigate("/nadplus/getting-started/step-7", { replace: true });
    } else {
      navigate("/nadplus/getting-started/step-6", { replace: true });
    }
  }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem(
      `Do_you_have_any_allergies_or_sensitivities_to_${isSermorelinPage ? "Sermorelin" : "NAD"}`
    );
    if (saved) {
      const parsed = JSON.parse(saved);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);

    localStorage.setItem(
      `Do_you_have_any_allergies_or_sensitivities_to_${isSermorelinPage ? "Sermorelin" : "NAD"}`,
      JSON.stringify({
        key: `Do_you_have_any_allergies_or_sensitivities_to_${isSermorelinPage ? "Sermorelin" : "NAD"}`,
        value: option,
      })
    );

    localStorage.setItem("completed-step-7", "true");
    if(isSermorelinPage){
      if (option === "Yes") {
        setTimeout(() => {
          navigate("/sermorelin/disqualified");
        }, 1000);   
      } else {
        setTimeout(() => {
          navigate("/sermorelin/getting-started/step-8");
        }, 1000);    
      }
    }else{
      if (option === "Yes") {
        setTimeout(() => {
          navigate("/nadplus/disqualified");
        }, 1000); 
      } else {
        setTimeout(() => {
          navigate("/nadplus/getting-started/step-8");
        }, 1000); 
      }
    }
  };

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-6");
    }else{
      navigate("/nadplus/getting-started/step-6");
    }
    
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={64} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            Do you have any allergies or sensitivities to {isSermorelinPage ? "Sermorelin" : "NAD+"}?
          </p>
          <div className="options options-box">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage7;